import styled, { css } from 'styled-components';

import { Col } from '@components/Grid';
import { ErrorMessageWrapper } from '@components/ErrorMessage';
import { ErrorDisplayLayout } from '@components/utils/form/Field';
import { SizeUnit } from '@utils/types';
export const ModalTitle = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const labelCss = css`
  padding-right: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;
export const KVKKTextStyle = styled.span`
  font-size: 14px;
`;

export const KVKKParagraphCheckBox = styled.div`
  cursor: pointer;
`;
export const initialState = {
  sms: false,
  phone: false,
  email: false,
};
export const Containers = styled.div`
  display: flex;
  align-items: center;
`;

export const Code = styled.span<{ marginLeft: SizeUnit }>`
  margin-left: ${(p) => p.marginLeft};
  font-size: 16px;
`;
export const Container = styled(Col)<ErrorDisplayLayout>`
  display: flex;
  flex-direction: ${(p) => p.layout};
  row-gap: 10px;
  column-gap: 15px;
  position: relative;
  &[data-error='true'] {
    & div {
      border-color: ${({ theme }) => theme.palette.tomato} !important;
    }
    ${ErrorMessageWrapper} {
      position: ${(p) => p.layout === 'column' && 'relative'};
    }
  }
`;
